(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // const div = document.getElementById("right-prevent");
  // div.addEventListener("contextmenu", (e) => {e.preventDefault()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SD-hero-video"] && !window.DesignMode) return;
  try {
    
  const div = document.getElementById("video-container");
  div.addEventListener("contextmenu", (e) => {e.preventDefault()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["SD-Tabs"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {

    var pnl = document.getElementsByClassName("panel-head");

    for (let i = 0; i < pnl.length; i++) {

        pnl[i].addEventListener("click", function () {

            this.classList.toggle("faq-active");
            var panelBody = this.nextElementSibling;

            if (panelBody.style.height != 0) {
                panelBody.style.height = null;
            } else {
                panelBody.style.height = "100px";
            }

        });

    }

});

  } catch(e) { console.error(e); }
})();

})();
